import { render, staticRenderFns } from "./home-carousel.vue?vue&type=template&id=23ca7d71&scoped=true"
import script from "./home-carousel.vue?vue&type=script&lang=js"
export * from "./home-carousel.vue?vue&type=script&lang=js"
import style0 from "./home-carousel.vue?vue&type=style&index=0&id=23ca7d71&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23ca7d71",
  null
  
)

export default component.exports